import React from 'react';
import { useTranslation } from 'react-i18next';

const CookiePreferencesLink = () => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className="cookie-preferences-launch"
      onClick={() => window.dispatchEvent(new Event('aipsyhelp:open-cookie-preferences'))}
    >
      {t('cookies.manage', 'Cookie settings')}
    </button>
  );
};

export default CookiePreferencesLink;
